import React,{Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Icons from '../../Components/Icons/Icons';
import Inputs from '../Inputs/Inputs';
import InputsField from '../FieldsInput/Inputs';
import Wrp from '../../hoc/Wrp/Wrp';
import {getDateFormat,getDateFormatPicker} from '../../Utils/UserFunctions';
import DrillDown from '../DrillDown';
import DropDownSearch from '../DropDownSearch';
import * as ShipConstants from '../../Global/Constants';

class FiltersComponent extends Component {

	static propTypes = {
	    filters: PropTypes.array,
	    changeHandler: PropTypes.func,
  	};

  	static defaultProps = {
	    filters: [],
	    isRelatedWindow:false,
	    fieldOptions: [],
	    clickHandler:()=>{}
  	};

	state = {
		sampleObject : {
            tableDescriptorId: "",
            fieldFilterId: "",
            fieldFilter: [],
            values: [],
            lineNumber: 1,
            logicalOperator: "0",
            filterObject: null,
            fieldType: '',
            fieldTypeId : '',
            multiSelectOptions : [],
            lookupWindowName : '',
            absolute_window : '',
            absolute_window1: ''
        }
	}

	/*Logical operation radio button change handler*/
	operandChangeHandler = (e,index) => {
		const {filters,changeHandler} = this.props;
		const {name,value,checked} = e.target;
		const returnValue = {
			index: index,
			name: "logicalOperator",
			value: value
		}
		changeHandler(returnValue);
	}

	/*Field and filter type change handler*/
	inputChangeHandler = (value,name,index) => {
		const {filters,changeHandler} = this.props;
		const returnValue = {
			index: index,
			name: name,
			value: value
		}
		changeHandler(returnValue);
	}

	/*Drilldown change handler*/
	drillDownChangeHandler = (selectedField, index) => {
		const {filters,changeHandler} = this.props;
		let selectedData = null;
  		if(selectedField) {
            const fieldCount = selectedField.length;
            if(fieldCount > 0) {
                const selectedFieldObj = selectedField[fieldCount-1];

                let absoluteWindow = '';
                if(fieldCount > 1) {
	                selectedField.map((arr,i) => {
	                    if(arr.system_window_name) {
	                        absoluteWindow += i === 0 ? arr.id : '.'+arr.id;
	                    }
	                })
            	}

                const filterdata = selectedFieldObj.filters;
                const fieldType = selectedFieldObj.field_type;
                const fieldName = selectedFieldObj.field_name;
                const options = selectedFieldObj.options;
                const id = selectedFieldObj.id;
                const lookupName = selectedFieldObj.lookUpName;
                const fieldTypeId = selectedFieldObj.fieldTypeId;
                let optionsArr = [];
                if(options.length > 0) {
                  options.map((arr,i) => {
                    const value = {
                      "value": arr.key,
                      "label": arr.value,
                    }
                    optionsArr.push(value);
                    return true;
                  }) 
                }

                let fieldFilterId = '';
                let filterObject = null;

                if(filterdata && filterdata.length > 0) {
					if(filterdata[0].name === 'is changed') {
						fieldFilterId = filterdata[1].filterId;
						filterObject = filterdata[1];
					}else {
						fieldFilterId = filterdata[0].filterId;
						filterObject = filterdata[0];
					}
				}

				let lookupWindowNameId = '';
				let lookupWindowName = lookupName;
				let isNotes = false;

				if(selectedFieldObj.dependent_layout) {
                	lookupWindowNameId = selectedFieldObj.dependent_layout.window_id;
              	}
              
				if(fieldType === 'Email') {
					lookupWindowName = "Email";
					lookupWindowNameId = ShipConstants.EMAIL_WINDOW_ID;
				}

				if(lookupName === 'Notes') {
					isNotes = true;
				}else {
					isNotes = false;
				}

				if(fieldType === 'User') {
				  lookupWindowName = "User";
				  lookupWindowNameId = ShipConstants.USERS_WINDOW_FIELD_ID;
				}

                selectedData = {
                	table_descriptor_id: id,
                	field_name: fieldName,
                	field_type: fieldType,
                	fieldTypeId: fieldTypeId,
                	options: options,
                	lookupName: lookupName,
                	filters: filterdata,
                	optionsArr: optionsArr,
                	absolute_window: absoluteWindow,
                	absolute_window1: selectedField,
                	filterObject: filterObject,
                	fieldFilterId: fieldFilterId,
                	selectedFieldObj: selectedFieldObj,
                	lookupWindowNameId: lookupWindowNameId,
                	lookupWindowName: lookupWindowName,
                	isNotes: isNotes
                }
            }
        }

        const returnValue = {
			index: index,
			name: "drillDown",
			value: selectedData
		}

		changeHandler(returnValue);
  	}

  	/*Date field and input field change handler*/
  	filterOnChange = (e,index,mode,isMultiSelect,valueIndex=0) => {
  		const {filters,changeHandler} = this.props;
        const dateFormat = 'YYYY-MM-DD HH:MM:ss';
        let datevalue = '';
        let dateSysvalue = '';
        let value = [];
        if(e === '') {
          datevalue = '';
        }else if(mode === 'Date') {
          datevalue = e.format ? e.format('yyyy-MM-DD HH:mm:ss') : e; 
        }else if(mode === 'DateTime') {
          datevalue = e.format ? e.format('yyyy-MM-DD HH:mm:ss') : e;
          datevalue = moment(datevalue, getDateFormat('DateTime')).format(dateFormat);
        }else if(mode === 'inputField') {
          datevalue = e.target.value;
        }else if(mode === 'time') {
          datevalue = e;
        }
        if(isMultiSelect === true || isMultiSelect === 'true') {
            value = [{
                value : valueIndex === 0 ? datevalue : filters[index].values[0] ? filters[index].values[0].value : ''
            },{
                value : valueIndex === 1 ? datevalue : filters[index].values[1] ? filters[index].values[1].value : ''
            }]
        }else {
            value = [{
                value : datevalue,
            }]
        }

        const returnValue = {
			index: index,
			name: "values",
			value: value
		}

		changeHandler(returnValue);
        
    }

    handleChangeMultiple = (selectedOption, index) => {
    	const {filters,changeHandler} = this.props;
        const returnValue = {
			index: index,
			name: "values",
			value: selectedOption
		}
		changeHandler(returnValue);
        // rulesValueChangeHandlerUsingName('values',selectedOption, index);
    }

    handleChange = (selectedOption, index) => {  
    	const {filters,changeHandler} = this.props;
        const returnValue = {
			index: index,
			name: "values",
			value: selectedOption
		}
		changeHandler(returnValue);
    }

    handleInputChange = (val,index,data) => {
    	const {filters,changeHandler} = this.props;
        let existVal = data.values ? data.values :[];
        existVal.push(val);
        const returnValue = {
			index: index,
			name: "values",
			value: existVal
		}
		changeHandler(returnValue);
    }

    handleDelete = (i,index,data) => {
    	const {filters,changeHandler} = this.props;
        let existVal = data.values;
        existVal.splice(i,1);
       	const returnValue = {
			index: index,
			name: "values",
			value: existVal
		}
		changeHandler(returnValue);
    }

    lookSelectHandler = (res, index) => {
        const {filters,changeHandler} = this.props;
       	const returnValue = {
			index: index,
			name: "values",
			value: res.value
		}
		changeHandler(returnValue);
    }

    lookSelecMultitHandler = (res, index) => {
        const {filters,changeHandler} = this.props;
       	const returnValue = {
			index: index,
			name: "values",
			value: res.value.split(',')
		}
		changeHandler(returnValue);
    }

	render() {
		const {filters,windowFields,addFilters,deleteFitler,fieldOptions,isRelatedWindow} = this.props;
		const {operandChangeHandler,drillDownChangeHandler,filterOnChange,
				handleChangeMultiple,handleChange,handleInputChange,handleDelete,
				inputChangeHandler,lookSelectHandler,lookSelecMultitHandler} = this;
		return (
		<div className="form-group">
            <ol className="workFlow_Count">
                { filters && Array.isArray(filters) && filters.length > 0 ?   
                	filters.map((filterItem,filterIndex) => {

	                    let fieldFilterOptions = [];
	                    if(filterItem.fieldFilter) {
	                        filterItem.fieldFilter.map((filterOptionItem, filterOptionIndex) => {
	                            if(filterOptionItem.used_modules_enum === 0 || filterOptionItem.used_modules_enum === 1) {
	                                fieldFilterOptions.push({value:filterOptionItem.filterId,label:filterOptionItem.name})
	                            }
	                        })
	                    }

                     	let val = '';
                        if(filterItem.fieldType === 'MultiSelect' || filterItem.fieldType === 'PickList' || filterItem.fieldType === 'MultiLookup') {
                            val = filterItem.values ? filterItem.values : [];
                        }else {
                            if(filterItem.values) {
                                if(filterItem.values[0]) {
                                    val=filterItem.values[0].value;
                                }else {
                                    val = "";
                                }
                            }
                        }
						// console.log('filterItem',filterItem);
                    	return(
                        	<Wrp key={filterIndex}>
		                        {filterIndex !== 0 ?
			                        <div className="label-align-center p-1">
			                            <div className="selectgroup">
			                                <label className="selectgroup-item mb-0">
			                                    <input type="radio" 
			                                    	name={"logicalOperator"+filterIndex} 
			                                    	value="AND" className="selectgroup-input" 
			                                    	onChange={e => operandChangeHandler(e, filterIndex)}  
			                                    	checked={filterItem.logicalOperator.toLowerCase() === "and" ? true : false} />
			                                    <span className="selectgroup-button selectgroup-button-icon padding025"> 
			                                    	<small> AND </small> 
			                                    </span>
			                                </label>
			                                <label className="selectgroup-item mb-0">
			                                    <input type="radio" 
			                                    	name={"logicalOperator"+filterIndex} 
			                                    	value="OR" className="selectgroup-input" 
			                                    	onChange={e => operandChangeHandler(e, filterIndex)} 
			                                    	checked={filterItem.logicalOperator.toLowerCase() === "or" ? true : false} />
			                                    <span className="selectgroup-button selectgroup-button-icon padding025"> 
			                                    	<small> OR </small> 
			                                    </span>
			                                </label> 
			                            </div>
			                        </div>
		                        : null }
                        	<li className="workFlow_conditions workFlow-row position-relative">
	                            <div className="clearfix">
	                                <div className="col-4 float-left">
	                                { isRelatedWindow === true ?
	                                	<DropDownSearch
											options={fieldOptions}
											values={filterItem.tableDescriptorId}
											changeHandler={e=>inputChangeHandler(e,"tableDescriptorId",filterIndex)}
										/>
	                                	:
	                                    <DrillDown 
	                                    	selectedValue={filterItem.absolute_window1} 
	                                    	drillId={"drill"+filterIndex} 
	                                    	fieldDetails={windowFields} 
	                                    	selectHandler={e=>drillDownChangeHandler(e, filterIndex)} 
	                                    	isConditionApplied={true} />
	                                }
	                                </div>	 
	                                <div className="col-4 float-left">
	                                    {filterItem.tableDescriptorId !== '' ?
	                                    <DropDownSearch
	                                        options={fieldFilterOptions}
	                                        values={filterItem.fieldFilterId}
	                                        changeHandler={e=>inputChangeHandler(e,"fieldFilterId",filterIndex)}
	                                    />
	                                    : null}
	                                </div>

	                                <div className="col-3 float-left">
	                                    {filterItem.tableDescriptorId !== '' && filterItem.filterObject && filterItem.filterObject.input_value_type ?
	                                    <Wrp>  
	                                    {
	                                        (filterItem.fieldType === 'DateTime' || filterItem.fieldType === 'Date') && filterItem.filterObject.input_value_type !== "Integer" ?
	                                        
	                                        <InputsField                                                                
	                                        attr1={filterIndex} 
	                                        attr4={filterItem.filterObject.has_multiple_input ? 1 : 0 } 
	                                        filterOnChange={filterOnChange} 
	                                        handleChange={handleChange}
	                                        handleChangeMultiple={handleChangeMultiple}
	                                        value={ val } 
	                                        fieldtype={filterItem.fieldType} 
	                                        filterObject={filterItem.filterObject}
	                                        options={filterItem.multiSelectOptions}
	                                        lookupWindowName={filterItem.lookupWindowName}
	                                        lookupWindowNameId={filterItem.lookupWindowNameId}
	                                        lookSelectHandler={lookSelectHandler}
	                                        lookSelecMultitHandler={lookSelecMultitHandler}
	                                        attr5={0}
	                                        values={filterItem.values}
	                                        isNotes={filterItem.isNotes}
	                                        />

	                                        : 

	                                        <InputsField 
	                                        attr1={filterIndex} 
	                                        attr4={filterItem.filterObject.has_multiple_input ? 1 : 0 } 
	                                        filterOnChange={filterOnChange} 
	                                        handleChange={handleChange}
	                                        handleChangeMultiple={handleChangeMultiple}
	                                        value={ val } 
	                                        fieldtype={filterItem.fieldType} 
	                                        filterObject={filterItem.filterObject}
	                                        options={filterItem.multiSelectOptions}
	                                        lookupWindowName={filterItem.lookupWindowName}
	                                        lookupWindowNameId={filterItem.lookupWindowNameId}
	                                        lookSelectHandler={lookSelectHandler}
	                                        lookSelecMultitHandler={lookSelecMultitHandler}
	                                        attr5={0}
	                                        handleInputChange={e=>handleInputChange(e,filterIndex,filterItem)}
	                                        handleDelete={e=>handleDelete(e,filterIndex,filterItem)}
	                                        values={filterItem.values}
	                                        isNotes={filterItem.isNotes}
	                                        />
	                                    }
	                                    {filterItem.filterObject ? 
	                                        filterItem.filterObject.has_multiple_input === true || filterItem.filterObject.has_multiple_input === 'true' ? 
	                                            <InputsField 
	                                                attr1={filterIndex} 
	                                                attr4={filterItem.filterObject.has_multiple_input ? 1 : 0 } 
	                                                filterOnChange={filterOnChange} 
	                                                handleChange={handleChange}
	                                                handleChangeMultiple={handleChangeMultiple}
	                                                value={ filterItem.values ? filterItem.values[1] ? filterItem.values[1].value : '' : ''} 
	                                                fieldtype={filterItem.fieldType} 
	                                                filterObject={filterItem.filterObject}
	                                                options={filterItem.multiSelectOptions}
	                                                lookupWindowName={filterItem.lookupWindowName}
	                                                lookupWindowNameId={filterItem.lookupWindowNameId}
	                                                lookSelectHandler={lookSelectHandler}
	                                                lookSelecMultitHandler={lookSelecMultitHandler}
	                                                attr5={1}
	                                                values={filterItem.values}
	                                                isNotes={filterItem.isNotes}
	                                                />
	                                        : null
	                                    : null}  
	                                    </Wrp>  	                                                             
	                                    : null }
	                                </div>
	                                
	                                <div className="icon-right mt-2 mr-2"> 
	                                	{/*<a href="#" onClick={addFilters} className="pr-1">  
	                                        <i className="fas fa-plus third_light_color"></i>
	                                    </a>*/}
	                                    <a onClick={() => deleteFitler(filterIndex)} className="cursor-pointer">
	                                        {/*<i className="far fa-trash-alt third_light_color"></i>*/}
	                                        <Icons iconType='Delete' />
	                                    </a>
	                                {/*
	                                filters.length === filterIndex+1 ?
	                                    <a href="#" onClick={addFilters} className="">  
	                                        <i className="fas fa-plus third_light_color"></i>
	                                    </a>
	                                : null
	                                */}
	                                {/*
	                                    filters.length > 1 ?
	                                    <a onClick={() => deleteFitler(filterIndex)} className="cursor-pointer">
	                                        <i className="far fa-trash-alt third_light_color"></i>
	                                    </a>
	                                    : null
	                                */}
	                                </div>
	                                
	                            </div>
	                        </li>
                        </Wrp>
                    )   
                })
                :
                ''
                }
            </ol>
        </div> 
        )
	}

}

export default FiltersComponent;